// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Block           = require("bs-platform/lib/js/block.js");
var Curry           = require("bs-platform/lib/js/curry.js");
var Firebase        = require("./ffi/Firebase");
var Firebase$1      = require("firebase");
var LoginScreen     = require("./screen/LoginScreen");
var ReasonReact     = require("reason-react/lib/js/src/ReasonReact.js");
var DashboardScreen = require("./screen/DashboardScreen");

((require('./app.css')));

var component = ReasonReact.reducerComponent("App");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      Firebase.auth.onAuthStateChanged((function (u) {
              if (u == null) {
                return /* () */0;
              } else {
                return Curry._1(self[/* send */4], /* UserLogin */[u]);
              }
            }));
      Firebase.auth.setPersistence(Firebase$1.auth.Auth.Persistence.LOCAL).then((function () {
              return Promise.resolve((Firebase.ui.start(LoginScreen.authContainer, {
                                signInFlow: "popup",
                                signInOptions: /* array */[Firebase$1.auth.GoogleAuthProvider.PROVIDER_ID],
                                callbacks: {
                                  signInSuccess: (function (user) {
                                      return Curry._1(self[/* send */4], /* UserLogin */[user]);
                                    })
                                }
                              }), /* () */0));
            }));
      return /* NoUpdate */0;
    });
  newrecord[/* willUnmount */6] = (function () {
      Firebase.ui.reset();
      return /* () */0;
    });
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* user */0];
      if (match) {
        return ReasonReact.element(/* None */0, /* None */0, DashboardScreen.make(match[0], /* array */[]));
      } else {
        return ReasonReact.element(/* None */0, /* None */0, LoginScreen.make(/* array */[]));
      }
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* user : None */0,
              /* loggedIn : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, _) {
      return /* Update */Block.__(0, [/* record */[
                  /* user : Some */[action[0]],
                  /* loggedIn : true */1
                ]]);
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/app.re
// module id = 167
// module chunks = 0